import React from "react";
import PropTypes from "prop-types";
import { Form, Label, Button } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import { Link } from "react-router-dom";
import CustomSearch from "./CustomSearch";

const propTypes = {
  fieldID: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  labelSize: PropTypes.string,
  placeholder: PropTypes.string,
  buttonText: PropTypes.string,
  handleButtonClick: PropTypes.func.isRequired,
  showAddButton: PropTypes.bool
};

const defaultProps = {
  showAddButton: false,
  placeholder: ""
};

class SearchField extends React.Component {
  state = {
    value: "",
    buttonOvered: false,
    onMouseOverAdd: false,
    resetButtonOvered: false
  };

  handleButtonClick = () =>
    this.props.handleButtonClick(this.props.fieldID, {
      busqueda: this.state.value
    });

  handleSelection = keySelected =>
    this.setState(state => ({ value: keySelected }));

  handleChange = (e, value) => this.setState(state => ({ value }));

  handleResetButtonClick = () => {
    this.setState(state => ({
      value: ""
    }));
    this.props.handleButtonClick(this.props.fieldID, { busqueda: "" });
  };

  onMouseButton = () =>
    this.setState(state => ({ buttonOvered: !state.buttonOvered }));

  onMouseOverAdd = () =>
    this.setState(state => ({ onMouseOverAdd: !state.onMouseOverAdd }));

  onMouseResetButton = () =>
    this.setState(state => ({ resetButtonOvered: !state.resetButtonOvered }));

  renderTextField = ({ input, ...others }) => (
    <CustomSearch fluid iconPosition="left" {...input} {...others} />
  );

  render() {
    const { handleSubmit } = this.props;
    return (
      <Form>
        <Form.Field>
          <Label
            content={this.props.labelText}
            basic
            size={this.props.labelSize || "big"}
          />

          {this.props.showAddButton && (
            <Button
              circular
              as={Link}
              to={this.props.botonLink}
              content={this.props.linkText}
              floated="right"
              icon="add"
              color="pink"
              inverted={!this.state.buttonAddOvered}
              onMouseEnter={this.onMouseOverAdd}
              onMouseLeave={this.onMouseOverAdd}
            />
          )}
        </Form.Field>
        <Form.Field>
          <Field
            id={this.props.fieldID}
            name={this.props.fieldName}
            type="text"
            placeholder={this.props.placeholder}
            component={this.renderTextField}
            datosBusqueda={this.props.datosBusqueda}
            onSelect={this.handleSelection}
            onChange={this.handleChange}
            icon="search"
            value={this.props.value}
          />
        </Form.Field>
        <Form.Field>
          <Button.Group>
            <Button
              type="submit"
              color="pink"
              inverted={!this.state.buttonOvered}
              onClick={handleSubmit(this.handleButtonClick)}
              onMouseEnter={this.onMouseButton}
              onMouseLeave={this.onMouseButton}
            >
              {this.props.buttonText || "Buscar"}
            </Button>
          </Button.Group>
        </Form.Field>
      </Form>
    );
  }
}

SearchField.propTypes = propTypes;
SearchField.defaultProps = defaultProps;

export default reduxForm({})(SearchField);



// WEBPACK FOOTER //
// ./src/pages/shared/SearchField.jsx